import cn from 'classnames'
import { Empty, Form, Select as SelectAntd, Spin } from 'antd'
import { ReactComponent as ChevronDown16 } from 'assets/svg/ChevronDown16.svg'
import { ReactComponent as SelectClearIcon } from 'assets/svg/SelectClear.svg'
import { ReactComponent as CheckBoxIconFilled } from 'assets/svg/CheckBoxSelect.svg'
import { ReactComponent as CheckboxOutlineBlank } from 'assets/svg/CheckboxOutlineBlank.svg'
import { ReactComponent as Close16 } from 'assets/svg/Clos16.svg'
import { Props } from './types'
import './select.multi.scss'
import { LoadingOutlined } from '@ant-design/icons'
import {
  isSelectOptgroupEmptyValue,
  selectOptgroupEmptyValue
} from './optGroupEmpty'

const checkOnEmpty = (arr) => {
  return !!arr?.find((i) => !!i?.value || !!i?.options?.length)
}

const { Option, OptGroup } = SelectAntd

const Multi = ({ ...props }: Props): JSX.Element => (
  <Form.Item
    className={cn('custom-select', 'select-multi', props.className)}
    colon={false}
    {...props.propsItem}
    name={
      (props.options.length && checkOnEmpty(props.options)) || props.alwaysName
        ? props.propsItem?.name
        : ''
    }
  >
    <SelectAntd
      getPopupContainer={(node) => node}
      filterOption={(input, option) => {
        const value = option?.props?.value
        if (isSelectOptgroupEmptyValue(value)) {
          return !input
        }
        return (
          option?.props?.children?.[1]?.props?.children
            ?.toLowerCase?.()
            .includes(input?.toLowerCase()) ?? false
        )
      }}
      {...props.propsSelect}
      mode="multiple"
      maxTagCount="responsive"
      placement="bottomLeft"
      dropdownClassName="custom-select__dropdown"
      suffixIcon={<ChevronDown16 />}
      clearIcon={<SelectClearIcon />}
      removeIcon={<Close16 />}
      menuItemSelectedIcon={<CheckBoxIconFilled />}
      notFoundContent={
        props.propsSelect?.loading ? (
          <div className="full-width flex justify-center mt-16 mb-16">
            <Spin size="large" indicator={<LoadingOutlined spin />} />
          </div>
        ) : undefined
      }
      maxTagPlaceholder={(values) => `+${values.length}`}
      showArrow
      showSearch
    >
      {props.options.map((option, groupIndex) =>
        !option?.options ? (
          <Option
            value={option.value}
            disabled={option?.disabled}
            className="select-multi_option"
            key={option.value}
          >
            <CheckboxOutlineBlank className="select-multi_blank-checkbox" />
            <div className="select-multi_option-text">{option.label}</div>
          </Option>
        ) : (
          <OptGroup
            label={option.label}
            key={option.key ?? `${String(option.label)}-${groupIndex}`}
          >
            {!!option.options.length ? (
              option.options.map((i) => (
                <Option
                  className="select-multi_option"
                  value={i.value}
                  key={i.value}
                >
                  <CheckboxOutlineBlank className="select-multi_blank-checkbox" />
                  <div className="select-multi_option-text">{i.label}</div>
                </Option>
              ))
            ) : (
              <Option
                disabled
                value={selectOptgroupEmptyValue(groupIndex)}
                key={selectOptgroupEmptyValue(groupIndex)}
                className="custom-select__optgroup-empty-option"
              >
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description="No data"
                />
              </Option>
            )}
          </OptGroup>
        )
      )}
    </SelectAntd>
  </Form.Item>
)

export default Multi
